"use client"

import { Typography } from "@/shared/ui/atoms"
import { DirectionIcon } from "@/shared/ui/atoms/SVGIcons/BaseIcons"
import { PartnerHospitalOperation } from "@/entities/hospital/api/types"
import SummaryCard from "../../molecules/SummaryCard"
import useHospitalUIStore from "@/widgets/hospital/model/store"
import { CustomButton } from "@/shared/ui/molecules"
import { DoctorProfile } from "../../molecules"
import { getDoctorPositionLabel } from "@/widgets/hospital/lib/doctorPosition"
import { scrollToHospitalTabs } from "@/widgets/hospital/lib/scrollToHospitalTabs"
import { useTranslations } from "next-intl"

interface PartnerHospitalSummaryProps {
  partnerHospitalOperation: PartnerHospitalOperation
}

const PartnerHospitalSummary = ({ partnerHospitalOperation }: PartnerHospitalSummaryProps) => {
  const t = useTranslations()
  const { introduction, doctors, equipmentOverview } = partnerHospitalOperation
  const doctor = doctors[0]
  const { setSelectedTab } = useHospitalUIStore()

  const summaryCardList = [
    {
      thumbnail: introduction.thumbnailUrl,
      title: t("partnerHospitalSummary.cards.introduction"),
      content: <Typography size={13} className="text-gray-600 line-clamp-2 text-overflow-ellipsis">{introduction.introduction}</Typography>,
    },
    {
      thumbnail: doctor.profileImageUrl,
      title: `${doctor.name} ${getDoctorPositionLabel(doctor.positionCode)}`,
      content: <DoctorProfile doctor={doctor} />
    },
    {
      thumbnail: equipmentOverview.equipmentThumbnailUrl,
      title: t("partnerHospitalSummary.cards.equipment"),
      content: <Typography size={13} className="text-gray-600">{equipmentOverview.equipmentDescription}</Typography>,
    },
  ]
  return (
    <div className="px-4 pt-[26px] pb-[22px]">
      <div className="mb-3 flex items-center justify-between">
        <Typography size={18} className="text-gray-900 font-bold">
          {t("partnerHospitalSummary.title")}
        </Typography>
        <CustomButton
          onClick={() => {
            setSelectedTab("hospitalInfo")
            requestAnimationFrame(() => scrollToHospitalTabs({ behavior: "smooth" }))
          }}
        >
          <Typography size={14} className="flex items-center text-gray-600">
            {t("common.more")} <DirectionIcon size={16} rotate={270} className="text-gray-400" />
          </Typography>
        </CustomButton>
      </div>
      <div>
        {summaryCardList.map((card) => (
          <SummaryCard key={card.title} thumbnail={card.thumbnail} title={card.title} className="border-b border-gray-100 last:border-b-0">
            {card.content}
          </SummaryCard>
        ))}
      </div>
    </div>
  )
}

export default PartnerHospitalSummary